import { RootState } from '@/lib/redux/store';
import { createSelector } from '@reduxjs/toolkit';
import { AccountTransaction } from '../types';
import { SerializableAccountTransaction } from './transactions.slice';

// Base selector
const selectTransactionsState = (state: RootState) => state.transactions;

// Helper to convert serializable transaction back to AccountTransaction
const deserializeTransaction = (
  transaction: SerializableAccountTransaction
): AccountTransaction => {
  return {
    ...transaction,
    transaction_date: new Date(transaction.transaction_date),
  } as AccountTransaction;
};

// Get all transactions (converted back to AccountTransaction with Date objects)
export const selectAllTransactions = createSelector(
  selectTransactionsState,
  (transactions) => {
    if (!transactions.transactions) return null;
    return transactions.transactions.map(deserializeTransaction);
  }
);

// Get a specific transaction by debit_id
export const selectTransactionByDebitId = createSelector(
  [selectAllTransactions, (_state: RootState, debitId: string) => debitId],
  (transactions, debitId) => {
    if (!transactions) return null;
    return transactions.find(
      (transaction) => transaction.type === 'debit' && transaction.id === debitId
    );
  }
);
